import api from '@mint-lib/api';
import { useCrucialQuery } from '@mint-lib/query-client';

import { queryClient } from '../api/queries/client.js';
import { MEDIA_PLAN_ITEMS_META } from '../constants/EndpointConstants.js';
import { QueryKey } from '../constants/queryKeys.js';
import { MetaResponseSchema, type MetaResponse } from '../types/buyingPlan.js';
import { useSelectedBuyingPlanId } from './useSelectedBuyingPlanId.js';

const getBuyingPlanMeta = async (buyingPlanId: number) => {
  const response = await api.get(MEDIA_PLAN_ITEMS_META, {
    params: {
      media_plan_id: buyingPlanId,
    },
  });

  return MetaResponseSchema.parse(response.data);
};

export const useGetBuyingPlanMetaData = (buyingPlanId: number | null) => {
  const { data, isLoading, isError } = useCrucialQuery({
    queryKey: [QueryKey.BUYING_PLAN_META, buyingPlanId],
    queryFn: () => getBuyingPlanMeta(buyingPlanId ?? 0),
    staleTime: Infinity,
    enabled: !!buyingPlanId,
  });

  return { data, isLoading, isError };
};

export const refetchBuyingPlanMetaData = async (buyingPlanId: number) => {
  return await queryClient.refetchQueries({
    queryKey: [QueryKey.BUYING_PLAN_META, buyingPlanId],
  });
};

export const useBuyingPlanMetaChannels = () => {
  const selectedPlanId = useSelectedBuyingPlanId();
  const data = queryClient.getQueryData<MetaResponse>([
    QueryKey.BUYING_PLAN_META,
    selectedPlanId,
  ]);

  return data?.rows.channels;
};

export const useBuyingPlanMetaColumns = () => {
  const selectedPlanId = useSelectedBuyingPlanId();
  const data = queryClient.getQueryData<MetaResponse>([
    QueryKey.BUYING_PLAN_META,
    selectedPlanId,
  ]);

  return data?.columns;
};
